<template>
	<div>
		<buttonlist
			@opentable="opentable"
			@help="help"
			@search="search"
			@reflash="reflash"
			@exps="exps"
			ref="SetBtn"
		></buttonlist>
		<wTable
				id="xpane-0"
				:data="dataSet"
				:loading="loading"
				queryData="APSResultViewInfo"
				:header="tableHeader"
				:option="tableOption"
				:checkflg="false"
				ref="singleTable"
		></wTable>
		<!--<el-table
			id="xpane-0"
			:data="dataSet"
			v-loading="loading"
			:highlight-current-row="true"
			show-overflow-tooltip="true"
			border
			stripe
			size="mini"
			:height="tableHeight"
			header-row-class-name="headerclass"
			style="width: 100%; margin-top:0px"
			ref="singleTable"
		>
			<el-table-column type="selection" v-if="false"></el-table-column>
			<el-table-column show-overflow-tooltip prop="bind_code" :label="$t('getapi[6337]')"></el-table-column>
			<el-table-column show-overflow-tooltip prop="so_code" :label="$t('getapi[4285]')"></el-table-column>
			<el-table-column show-overflow-tooltip prop="routing_sequence_no" :label="$t('getapi[4286]')" align="right"></el-table-column>
			<el-table-column show-overflow-tooltip prop="start_time" :label="$t('getapi[6339]')"></el-table-column>
			<el-table-column show-overflow-tooltip prop="end_time" :label="$t('getapi[4057]')"></el-table-column>
			<el-table-column show-overflow-tooltip prop="gongshi" :label="$t('getapi[6340]')" align="right"></el-table-column>
			<el-table-column show-overflow-tooltip prop="r_code" :label="$t('getapi[6341]')"></el-table-column>
			<el-table-column show-overflow-tooltip prop="remain_qty" :label="$t('getapi[6342]')" align="right"></el-table-column>
			<el-table-column show-overflow-tooltip prop="cdevicenm" :label="$t('getapi[12213]')"></el-table-column>
			<el-table-column show-overflow-tooltip prop="routing_road" :label="$t('getapi[12851]')"></el-table-column>
			<el-table-column show-overflow-tooltip prop="so_status" :label="$t('getapi[4489]')"></el-table-column>
			<el-table-column show-overflow-tooltip prop="routing_status" :label="$t('getapi[2510]')"></el-table-column>
			<el-table-column show-overflow-tooltip prop="workproc_name" :label="$t('getapi[4364]')"></el-table-column>
			<el-table-column show-overflow-tooltip prop="part_code" :label="$t('getapi[112]')"></el-table-column>
			<el-table-column show-overflow-tooltip prop="part_version" :label="$t('getapi[149]')"></el-table-column>
			<el-table-column show-overflow-tooltip prop="workcenter_name" :label="$t('getapi[882]')"></el-table-column>
			<el-table-column show-overflow-tooltip prop="processing_routing" :label="$t('getapi[12856]')"></el-table-column>
			<el-table-column show-overflow-tooltip prop="so_priority" :label="$t('getapi[6338]')" align="right"></el-table-column>
			<el-table-column show-overflow-tooltip prop="cut_no" :label="$t('getapi[8188]')"></el-table-column>
		</el-table>-->
		<el-row class="page">
			<el-col :span="18">
				<el-pagination
					@size-change="handleSizeChange"
					@current-change="handleCurrentChange"
					:page-sizes="[100, 200, 300, 400]"
					:page-size="pageSize"
					:pager-count="5"
					layout="total, sizes, prev, pager, next, jumper"
					:total="total"
				></el-pagination>
			</el-col>
			<el-col :span="6">
				<div style="text-align: right;line-height: 30px;color: #545c64;font-size: 95%;">{{$t('getapi[7980]')}}:{{ DbTbNames }}</div>
			</el-col>
		</el-row>
		<serce :isVisible="isVisible" queryData="APSResultViewInfo" ref="ser" @getser="serclick"></serce>
		<ctable :isVisible="false" :title="$t('getapi[6336]')" queryData="APSResultViewInfo" tabNo="0" ref="ctab"
				@getctab="sortclick"></ctable>
	</div>
</template>

<script>
import Common from '@/components/Common';
import Array from '@/components/Array';
export default {
	name:'2_apsresult',
    computed: {
        tableHeight(){
            return this.$windowSize.tableHeight3
        },
        tableOption() {
            return {
                border: true,
                height: this.$windowSize.tableHeight3,
                maxHeight: this.$windowSize.tableHeight3,
            }
        },
    },
	data() {
		return {
            tableHeader: [],
			dataSet: [], // 主表数据
			isVisible: false, // 查询列表是否显示
			queryData: [], // 查询数组
			userData: [], // 用户信息
			DbTbNames: '',
			pageIndex: 1, // 当前页
			pageSize: this.$http.getPageSize('2_apsresult'), // 当前页数据量
			SelectIndexs: 1, //当前页面
			total: 0, // 数据总量
			loading: false, // 主表加载状态
            scrollTop:0,
		};
	},
    watch: {
        dataSet: function () {
            let that = this
            that.$nextTick(function () {
                that.$processdata.initForm(0)
            })
        },
    },
	mounted: function() {
		let that = this;
        that.colsort()
		that.userData = sessionStorage.getItem('userData');
		that.authority();
	},
    activated () {
        let that = this
        setTimeout(() => {
            that.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                that.scrollTop = res.target.scrollTop
            },false)
        }, 5000);
        // 路由跳转回来滚动到离开时的位置
        this.$nextTick(()=> {
            setTimeout(() => {
                this.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop;
            }, 13)
        })
    },
	methods: {
        colsort() {
            let that = this;
            that.$loadviewfields.Fileds('APSResultViewInfo', 0, PFileds => {
                that.tableHeader = PFileds;
            });
        },
        sortclick(val) {
            if (val == 1) {
                this.colsort();
            }
        },
        opentable() {
            this.$refs.ctab.clearInputs(true);
        },
        help(){
            this.$refs.SetBtn.showHelp(this.$options.name,this.$t("getapi[6336]"),this.$t("getapi[20]"));
        },
		authority() {
			let that = this;
            if(that.$loadviewfields.isEnableHelp(this.$options.name) == 1){
                that.$refs.SetBtn.SetOneBtnEnable('help',true);
            }
            that.$refs.SetBtn.SetOneBtnEnable('ctabel', true);
            if (that.total > 0) {
                that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
            } else {
                that.$refs.SetBtn.SetButtonEnable('search,refresh');
            }
		},
		handleSizeChange(val) {
			this.pageSize = val;
            this.$http.savePageSize('2_apsresult',val)
			this.getView();
			this.authority();
		},
		handleCurrentChange(val) {
			this.pageIndex = val;
			this.getView();
			this.authority();
		},
		// 查询
		search() {
			let that = this;
			that.isVisible = true;
			that.$refs.ser.clearInput(that.isVisible, 'APSResultViewInfo');
		},
		//获取查询条件
		serclick(val) {
			this.queryData = val;
			this.confirmGetView();
		},
		// 确认获取数据
		confirmGetView() {
			let that = this;
            that.pageIndex = 1
			that.isVisible = false;
			that.getView();
		},
		// 数据一览
		getView() {
			let that = this;
			that.loading = true;
			let datac = [];
			for (let i = 0; i < that.queryData.length; i++) {
				datac.push({
					query_Condition: that.queryData[i].query_Condition,
					query_field_type: that.queryData[i].Query_Field_Type,
					query_field_name: that.queryData[i].Query_Field_Name,
					query_sort: that.queryData[i].query_sort,
					row_sign: that.queryData[i].row_sign
				});
			}
			let data = {
				PageIndex: that.pageIndex,
				PageSize: that.pageSize,
				SelectIndex: that.SelectIndexs,
				Param: datac
			};
			that.$http.urlpost('/Pro/SchPro/GetAPSResultView', data, function(res) {
				if (res.Success == 1) {
					that.dataSet = res.DataContent;
					that.total = res.Totals;
					that.loading = false;
					that.DbTbNames = res.DbTbNames;
					that.authority();
				} else {
					that.$message.error(that.$processdata.explainCallbackMsg(res.Msg));
				}
			});
		},
		// 刷新
		reflash() {
			let that = this;
			that.getView();
		},
		// 导出
		exps() {
			let that = this;
			let datac = [];
			for (let i = 0; i < that.queryData.length; i++) {
				datac.push({
					query_Condition: that.queryData[i].query_Condition,
					query_field_type: that.queryData[i].Query_Field_Type,
					query_field_name: that.queryData[i].Query_Field_Name,
					query_sort: that.queryData[i].query_sort,
					row_sign: that.queryData[i].row_sign
				});
			}
			let parm = {
				PageIndex: that.PageIndex,
				PageSize: that.PageSize,
				SelectIndex: that.SelectIndex,
				Ids: '',
				Param: datac
			};
            that.$refs.SetBtn.SetOneBtnEnable('exps',false);
			that.$http.urlpost('/Pro/SchPro/GetAPSResultViewToExecl', parm, function(res) {
                that.$refs.SetBtn.SetOneBtnEnable('exps',true);
				if (res.Success == 1) {
					let hrefurl = Common.Url + res.DataContent.URL;
					window.open(hrefurl);
				}
			});
		},
        exprouting(row){
            let pro = 0;
            let rname = ''
            if (row.finish_flag == 1) {
                pro = 3;
                rname = '已完工'
            } else {
                if (row.lock_schedule == 0) {
                    if (row.s_flag == 1) {
                        pro = 4;
                        rname = '进行中'
                    } else {
                        pro = 2;
                        rname = '正常';
                    }

                } else {
                    pro = 1;
                    rname = '锁定'
                }
            }
            return rname
		},
	}
};
</script>

<style scoped lang="less">
table {
	border-collapse: separate;
	border-spacing: 0px 5px;
	td {
		padding-left: 3px;
		white-space: pre;
	}
}
</style>
